import { extractChildren } from '../util/children';
var Component = /** @class */ (function () {
    function Component(vnode) {
        this.attrs = vnode.attrs;
    }
    Component.prototype.oninit = function (vnode) {
        this.patch(this.update, 'oncreate', 'onupdate', 'view');
    };
    Component.prototype.onbeforeupdate = function (vnode, old) {
        return true;
    };
    Component.prototype.onafterupdate = function () { };
    Component.prototype.onremove = function () { };
    Component.prototype.patch = function (to) {
        var methods = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            methods[_i - 1] = arguments[_i];
        }
        var comp = this;
        methods.forEach(function (method) {
            var original = comp[method] && comp[method].bind(comp);
            comp[method] = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return to.apply(comp, args.concat(original));
            };
        });
    };
    Component.prototype.update = function (vnode, original) {
        this.attrs = vnode.attrs;
        if (vnode.dom)
            this.dom = vnode.dom;
        this.children = extractChildren(vnode.children);
        this.onafterupdate();
        if (original) {
            if (process.env.NODE_ENV === 'production') {
                try {
                    return original(vnode);
                }
                catch (e) {
                    setTimeout(function () {
                        // Rethrow outside of this context so it can be picked up by Sentry
                        throw e;
                    });
                    return null;
                }
            }
            else {
                return original(vnode);
            }
        }
    };
    Component.prototype.view = function () {
        throw 'assert';
    };
    return Component;
}());
export { Component };
